<template>
  <div class="EditAddPhoneOperator">
    <el-dialog :visible.sync="dialog" @close="close" :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form v-loading="loadingPage" v-if="dialog" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
        <el-form-item prop="name" label="Nome">
          <el-input size="large" v-model="ruleForm.name" required></el-input>
        </el-form-item>
        <el-form-item prop="term" style="display: flex; flex-direction: column;">
          <span slot="label" style="display: flex; justify-content:start; text-align: left; line-height: 40px; ">
            Conteúdo do Termo
          </span>
          <vue-editor class="body-term" v-model="ruleForm.term" ></vue-editor>
        </el-form-item>
      </el-form>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between;">
        <el-button v-if="ruleForm.id" @click.prevent="delElement">Excluir</el-button>
        <div v-else></div>
        <el-button type="primary" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getAcceptTerms, putAcceptTerms, deleteAcceptTerms} from "@/app/domains/Config/services";
import {makeErrorFilds} from "@/app/plugins/utils";
import { VueEditor } from "vue2-editor";
export default {
  name: "dialogEditAddAcceptTerm",
  components: {
    VueEditor
  },
  props: ['show', 'idTerm'],
  watch: {
    'show': function (e) {
      this.dialog = e
    },
    'idTerm': function (e) {
      if (e !== '') {
        this.fetchAcceptTerms(e)
      }
    }
  },
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      dialog: false,
      loadingPage: false,
      rules: {},
      error: {},
      ruleForm: {},
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ]
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs['ruleForm'].resetFields()
      this.$refs['ruleForm'].clearValidate()
      this.ruleForm = {}
    },

    async submitForm (ruleForm) {
      this.loadingPage = true
      this.error = {}
      console.log(this.ruleForm);
      try {
        let response;
        if (this.ruleForm.id !== undefined) {
          response = await putAcceptTerms(this.ruleForm)
          this.$message({
            showClose: true,
            message: 'Termo de aceite alterado com sucesso',
            type: 'success'
          })
        }
        this.loadingPage = false
        this.close();
      } catch (e) {
        console.log(e)
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
        this.dialog = false
        this.close()
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    async delElement () {
      this.loadingPage = true
      this.error = {}
      console.log(this.ruleForm);
      try {
        let response;
        if (this.ruleForm.id !== undefined) {
          response = await deleteAcceptTerms(this.ruleForm.id)
          this.$message({
            showClose: true,
            message: 'Termo de aceite deletado com sucesso',
            type: 'success'
          })
        }
        this.loadingPage = false
        this.close();
        await this.fetchAcceptTerms();
      } catch (e) {
        console.log(e)
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
        this.dialog = false
        this.close()
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    handleAction () {},
    async fetchAcceptTerms (id) {
      this.loadingPage = true
      try {
        let response = await getAcceptTerms('/'+id)
        this.ruleForm = response.data
      } catch (e) {

        this.$message({
          showClose: true,
          message: e.body.message,
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.body-term {
  display: flex;
  flex-direction: column;
  max-height: 400px; /* Define a altura máxima */
  overflow-y: auto;  /* Habilita a rolagem vertical */
}
</style>